<template>
	<div class="team-member">
		<div class="team-member-container d-flex flex-column">
			<a :href="teamMemberDetailPage" class="mb-2">
			<div class="team-member-image-container">
				<div class="square-image">
					<img :src="srcObj" class="team-member-image" :alt="imageAltText"/>
				</div>
			</div>
			<div class="heading-5 person-naming-block-name team-member-name">{{teamMemberName}}</div>
			<div class="heading-6 person-naming-block-title team-member-title mb-3">{{teamMemberTitle}}</div>
			</a>
		</div>
	</div>
</template>


<style lang="scss">

.team-member {
	.team-member-name, .team-member-title {
		margin-left: 1rem;
		margin-right: 1rem;
		line-height: 1.5rem;
	}

	margin-bottom: 10px;	// /HL-117
}

.team-member-container {
	transition: background-color 0.15s;
	background-color: rgba(255, 255, 255, 0.0);
}

.team-member-image-container {
	transition: background-color 0.15s;
	background-color: transparent;
	margin-bottom: 20px;

	.square-image {
		overflow: hidden;
		padding-bottom: 100%;
		position: relative;
	
		img {
			object-fit: contain;
			width: auto;
			height: 100%;
			position: absolute;
		}
	}	
}

.team-member-container a {
	opacity: 1.0;
	transition: all 0.2s linear;

	&:hover {
		text-decoration: none;

		// .team-member-title, .team-member-name {
		// 	font-weight: 800;
		// }
		
		.team-member-image {
			opacity: 0.9;
		}

	}
}

.team-member-image {
	opacity: 1.0;
	transition: all 0.2s linear;
	width: 100%;
}

.team-member-name,
.team-member-title {
	color: $paragraphBlack;
}

.team-member-container:hover {
	background-color: $midnight;

	.team-member-name,
	.team-member-title {
		color: $white;
		margin-left: 1rem;
	}
}

.background-is-navy .team-member-container:hover {
	background-color: rgba(255, 255, 255, 0.1);
}

</style>

<script>
export default {
	props: {
		imageUrl: {
			type: String,
			default: '/images/asset-management-img.jpg'
		},
		imageAltText: {
			type: String,
			default: 'Team member headshot'
		},
		teamMemberDetailPage: {
			type: String,
			default: '#'
		},
		teamMemberName: {
			type: String,
			default: 'NAME'
		},
		teamMemberTitle: {
			type: String,
			default: 'TITLE'
		}
	},
	computed: {
		srcObj() {
			return this.imageUrl;
		}
	}
}
</script>